import { Currency, DepositPageVarsBanner } from '@freelancer/datastore';

export enum ApplicationType {
  DEPOSIT_PAGE = 'webAppDepositPage',
  DEPOSIT_MODAL = 'webAppDepositModal',
  VERIFICATION_PAGE = 'webAppVerificationPage',
  VERIFICATION_MODAL = 'webAppVerificationModal',
}

export interface DepositModalItem {
  description: string;
  amount: number;
}

export interface DepositContext {
  trackingToken?: string;
  backUrl?: string;
  banner: DepositPageVarsBanner;
  chargeAmount?: number;
  chargeCurrencyId?: number;
  items?: ReadonlyArray<DepositModalItem>;
  applicationType?: ApplicationType;
  // TODO: get rid of checkBalance
  // it's only for migration period from the old deposit page
  checkBalance: boolean;
  onSuccess(): void;
}

export type MessageEventFilter = (event: MessageEvent) => boolean;

export enum InterframeDepositResponseType {
  SUCCESS = 'success',
  PENDING = 'pending',
  CANCELLED = 'cancel',
  FAILURE = 'failure',
  ERROR = 'error',
  ERROR_DETAILED = 'error_detailed',
  ERROR_BIN = 'binError',
  ERROR_CART = 'cartError',
  ERROR_AUTH = 'authError',
  BAD_BIN = 'badBinError',
}

export interface DepositData {
  depositAmount: number;
  depositCurrency: Currency;
  paymentAmount: number;
  paymentCurrency: Currency;
}

export interface GenericPayload {
  user_id: number;
  threatmetrix_session: string;
  cancel_url: string;
  tracking_token?: string;
  back_url?: string;
  country_code: string;
  action: string;
  domain: string;
}

export const methodSelectionRadioControl = 'RadioControl';
